// Mirror of apps/backend-strapi/src/api/gpt-conversation/utils/renderPlanToMarkdown.js
// Renders a ScenariaPlan into the markdown format AIGeneratedGraph parses.
// Kept in sync by convention — if you change one, change the other.

import { ScenariaPlan } from "src/model/model";

// Absolute last-resort 360 description. Deliberately a renderable place,
// never scene.summary (a pedagogical objective): feeding the summary to
// Blockade as a skybox prompt was the original image-quality bug.
const GENERIC_360 = "Environnement de travail réaliste et photographiable en 360°";

export const renderPlanToMarkdown = (plan: ScenariaPlan): string => {
  const header =
    "# Scénario\n" +
    `Public cible: ${plan.targetAudience}\n` +
    "Objectifs:\n" +
    plan.learningObjectives.map((o) => `- ${o}`).join("\n") +
    (plan.constraints && plan.constraints.length
      ? `\nContraintes:\n${plan.constraints.map((c) => `- ${c}`).join("\n")}`
      : "") +
    (plan.stylisticPreferences && plan.stylisticPreferences.tone
      ? `\nTon: ${plan.stylisticPreferences.tone}`
      : "") +
    (plan.stylisticPreferences && plan.stylisticPreferences.length
      ? `\nLongueur souhaitée: ${plan.stylisticPreferences.length}`
      : "") +
    "\n\n";

  const scenes = plan.sceneOutline
    .map((scene, i) => {
      const mediaLabel = scene.mediaType === "video360" ? "Vidéo 360" : "Image 360";
      const refIds = scene.attachedImageRefIds || [];
      const imageDesc =
        refIds.length && plan.attachedImages
          ? plan.attachedImages.find((img) => refIds.includes(img.mediaId))?.description
          : null;
      // Preference: seed → image description → shared visualEnvironment →
      // generic placeholder. NEVER scene.summary (see GENERIC_360 above).
      const description360 =
        scene.blockadePromptSeed || imageDesc || plan.visualEnvironment || GENERIC_360;
      const interactionLines =
        scene.interactions && scene.interactions.length
          ? scene.interactions.map((inter) => `- **${inter}**`).join("\n") + "\n"
          : "";
      return (
        `### Scène n° ${i + 1}: ${scene.title}\n` +
        `${scene.summary}\n` +
        `Média: ${mediaLabel}\n` +
        `360 - ${description360}\n` +
        interactionLines
      );
    })
    .join("\n");

  return header + scenes;
};
